module.exports = __webpack_public_path__ + "img/1-3.71dabc6c.png";